import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DropsService {
  constructor(private http: HttpClient) {}

  list(): Observable<any> {
    return this.http.get<any>(`${environment.api}/admin/drops?token=G3tSh0es4L1f3`);
  }

  search(query: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/admin/drops/search?token=G3tSh0es4L1f3&q=${encodeURIComponent(query)}`
    );
  }

  add(styleId: string): Observable<any> {
    return this.http.post<any>(`${environment.api}/admin/drops?token=G3tSh0es4L1f3`, { styleId });
  }

  selections(id: number): Observable<any> {
    return this.http.get<any>(`${environment.api}/admin/drops/${id}/selections?token=G3tSh0es4L1f3`);
  }

  updateValue(id: number, value: number): Observable<any> {
    return this.http.patch<any>(`${environment.api}/admin/drops/${id}?token=G3tSh0es4L1f3`, { value });
  }

  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${environment.api}/admin/drops/${id}?token=G3tSh0es4L1f3`);
  }
}
